import { useThreadStore } from "@/store";
import { Loader2 } from "lucide-react";
import PropTypes from "prop-types";

/**
 * StreamingIndicator - Shows an animated indicator when a thread has an active stream
 */
export function StreamingIndicator({ threadId, className = "" }) {
  // Subscribe to activeStreams to ensure re-render when streams change
  const _activeStreams = useThreadStore((state) => state.activeStreams);
  const getStreamForThread = useThreadStore(
    (state) => state.getStreamForThread
  );

  // Get stream for this thread (will re-render when activeStreams changes)
  const activeStream = threadId ? getStreamForThread(threadId) : null;

  if (!activeStream || !activeStream.isActive) {
    return null;
  }

  return (
    <div
      className={`inline-flex items-center gap-1 text-[#2563eb] dark:text-[#99CEFF] ${className}`}
      title="Streaming in progress"
    >
      <Loader2 className="h-3 w-3 animate-spin" />
      <span className="text-xs font-medium">Streaming</span>
    </div>
  );
}

StreamingIndicator.propTypes = {
  threadId: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default StreamingIndicator;
